import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MasterService } from "src/app/services/master.service";
import { Page } from "src/app/model/Page";
import { FeatureResponseModel } from "src/app/model/FeatureResponseModel";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-secure-email-dashboard",
  templateUrl: "./email-dashboard.component.html",
  styleUrls: ["./email-dashboard.component.scss"],
})
export class EmailDashboardComponent implements OnInit {
  loaded: boolean = false;
  page: Page<FeatureResponseModel>;
  dataSource: MatTableDataSource<FeatureResponseModel> =
    new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  isSubmitDisabled: boolean = false;
  displayedColumns: string[] = [
    "id",
    "fileName",
    "subject",
    "emailSmsBody",
    "startTime",
    "endTime",
    "status",
    "count",
    // "displayOrder",
    "action",
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });

    this.loadData();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.loadData();
  }
  loadData() {
    this.masterService
      .getFileList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.loaded = true;
          this.page = page;
          this.dataSource = new MatTableDataSource(page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  download(key: number) {
    this.isLoading = true;
    console.log("keyyyyy", key);
    this.masterService.downloadEmailNotification(key).subscribe(
      (data) => {
        this.isSubmitDisabled = false;
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.downloadFile(data.base64File, data.fileName);
        } else {
          this.masterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.masterService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }
  downloadUpFile(key: number) {
    this.masterService.downloadUploadFile(key).subscribe(
      (data: any) => {
        console.log("data++++++++++++++++", data);
        if (data.status === "SUCCESS") {
          this.downloadFile1(data.data, data.fileName);
        } else {
          this.masterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.masterService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  downloadFile1(base64: string | ArrayBuffer, fileName: string) {
    const src = `data:text/csv;base64,${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
}
